import Component from "@glimmer/component";
import { service } from "@ember/service";
import { tracked } from "@glimmer/tracking";
import { ajax } from "discourse/lib/ajax";

export default class ShowBackupInfo extends Component {
  @service siteSettings;
  @service currentUser;

  @tracked showMigrateInfo = false;

  constructor() {
    super(...arguments);
    this.loadSiteInfo();
  }

  async loadSiteInfo() {
    if (this.currentUser?.id < 2) {
      const about = await ajax("/about.json");
      this.showMigrateInfo = (about?.about?.stats?.users_count ?? 0) < 3;
    }
  }

  <template>
    <div style="padding: 12px; background-color: #d1f0ff; color: #222;">
      Off-site backups for disaster recovery are created every 24 hours. This page
      only shows the backups you have made yourself.
    </div>
    {{#if this.showMigrateInfo}}
      <div style="padding: 12px; background-color: #fffbd6; color: #222;">
        <b>Important: </b>If you are migrating from another hosting provider then we
        recommend you to read
        <a href="https://www.communiteq.com/discoursehosting/kb/migrate-from-another-provider/" target="_blank">our migration guide</a>
        before attempting to restore a backup.
      </div>
    {{/if}}
  </template>
}
